import script from "./AddInterestedPartyModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddInterestedPartyModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddInterestedPartyModal.vue?vue&type=style&index=0&id=768c8505&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768c8505"]])

export default __exports__